import { render, staticRenderFns } from "./PortfolioSection.vue?vue&type=template&id=4e9f5ead&scoped=true"
import script from "./PortfolioSection.vue?vue&type=script&lang=js"
export * from "./PortfolioSection.vue?vue&type=script&lang=js"
import style0 from "./PortfolioSection.vue?vue&type=style&index=0&id=4e9f5ead&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9f5ead",
  null
  
)

export default component.exports